var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5035C11.999 8.63481 11.9417 8.76049 11.8404 8.85339C11.7392 8.94629 11.6022 8.99895 11.4589 9H1.632C1.48844 8.99987 1.35082 8.9475 1.24936 8.8544C1.1479 8.7613 1.09091 8.63509 1.09091 8.5035V8H10.9091V2.15L6.54545 5.75L1.09091 1.25V0.5C1.09091 0.367392 1.14838 0.240215 1.25067 0.146447C1.35296 0.0526784 1.4917 0 1.63636 0H11.4545C11.5992 0 11.7379 0.0526784 11.8402 0.146447C11.9425 0.240215 12 0.367392 12 0.5V8.5035ZM2.41855 1L6.54545 4.405L10.6724 1H2.41855ZM0 6H4.36364V7H0V6ZM0 3.5H2.72727V4.5H0V3.5Z",
    fill: "#F9FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.035febf7a22bf76ccb0877347a6d45bd.svg";
export { ForwardRef as ReactComponent };